<button type="button" id="{{ id }}" name="actionMenuBtn" class="btn" [disabled]="isDisabled" [ngClass]="btnStyleClass" [matMenuTriggerFor]="menu" [title]="title">
  {{ buttonText | translate}}
  <span [ngClass]="iconStyleClass" [class.open]="menuTrigger.menuOpen"></span>
</button>
<mat-menu #menu="matMenu" yPosition="below" [overlapTrigger]="false" class="cpq-button-menu-dropdown">
  @for (item of items; track item) {
    @if (checkIfItemIsVisible(item)) {
      <button type="button" id="{{ item.id }}" (click)="select(item)" class="mat-menu-button">{{ item.key | translate }}</button>
    }
    @if (item.hasSeparator) {
      <div class="separator"></div>
    }
  }
</mat-menu>